import Swiper from 'swiper/bundle';

export function initLogosSwipers(scope = document) {
    scope.querySelectorAll('[data-logos-swiper-root]').forEach((root) => {
        const instances = root.querySelectorAll('.js-logos-swiper');

        instances.forEach((el) => {
            if (el._swiper && typeof el._swiper.destroy === 'function') {
                el._swiper.destroy(true, true);
                el._swiper = null;
            }

            let data = {};
            try {
                data = JSON.parse(el.getAttribute('data-options') || '{}');
            } catch (_) {}

            const common = {
                loop: !!data.loop,
                speed: 500,
                autoplay: data.autoplay
                    ? {
                        delay: Number(data.delay || 3500),
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true
                    }
                    : false
            };

            const isDesktop = el.classList.contains('js-logos-swiper--desktop');

            if (isDesktop) {
                const next = root.querySelector('.logos-next');
                const prev = root.querySelector('.logos-prev');

                el._swiper = new Swiper(el, {
                    ...common,
                    slidesPerView: 1.3,
                    spaceBetween: 16,
                    navigation: (next && prev) ? { nextEl: next, prevEl: prev } : undefined,
                    breakpoints: {
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 24
                        },
                        992: {
                            slidesPerView: 5,
                            spaceBetween: 40
                        }
                    }
                });

                const getSlidesPerViewCurrent = () => {
                    const width = window.innerWidth;

                    if (width >= 992) return 5;
                    if (width >= 768) return 3;
                    return 1;
                };

                const toggleNav = () => {
                    if (!next || !prev || !el._swiper) return;

                    const totalSlides = el.querySelectorAll('.swiper-slide').length;
                    const visibleSlides = getSlidesPerViewCurrent();
                    const show = totalSlides > visibleSlides;

                    next.style.display = show ? '' : 'none';
                    prev.style.display = show ? '' : 'none';
                };

                el._swiper.on('init resize breakpoint update', toggleNav);
                toggleNav();
            }
        });
    });
}